import React from "react";

const Credits = () => (
  <div
    className="fixed bottom-3 left-4 z-40 text-white bg-black/50 px-4 py-1.5 rounded-lg text-xs font-sans md:text-sm"
  >
    A Fanwork Tribute to <span className="font-bold">Tinggal Meninggal</span><br />
    by <a href="https://filbert-fernandes-portfolio.vercel.app/" className="underline" target="_blank" rel="noopener noreferrer">Filbert Fernandes</a>. (<a href="https://github.com/filbertfernandes/tingning-fanwork" className="underline" target="_blank" rel="noopener noreferrer">Source Code</a>)
  </div>
);

export default Credits;
